'use client'
import dynamic from 'next/dynamic'

const AdminBoxContent = dynamic(() => import('./AdminBoxContent'), { ssr: false })

export default AdminBoxContent
